<template>
    <div class="record job">
        <div class="title">任务详情</div>
        <router-link to>
            <span @click="$router.back(-1)"><< 返回上一级</span>
        </router-link>
        <div class="main">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "taskDetailCom"
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/translator/work_record.scss";
</style>